"use client";

import { c as _c } from "react/compiler-runtime";
import { useReadContract } from "wagmi";
import { MEMES_MANIFOLD_PROXY_ABI } from "@/abis/abis";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import { useDropForgeMintingConfig } from "@/components/drop-forge/drop-forge-config";
import { areEqualAddresses } from "@/helpers/Helpers";
export function useIsDropForgeAdmin() {
  const $ = _c(12);
  const {
    address
  } = useSeizeConnectContext();
  const {
    contract,
    chain
  } = useDropForgeMintingConfig();
  const t0 = contract as `0x${string}`;
  const t1 = !!address;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      enabled: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== chain.id || $[3] !== t0 || $[4] !== t2) {
    t3 = {
      address: t0,
      chainId: chain.id,
      abi: MEMES_MANIFOLD_PROXY_ABI,
      functionName: "owner",
      query: t2
    };
    $[2] = chain.id;
    $[3] = t0;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const readResult = useReadContract(t3);
  let t4;
  if ($[6] !== address || $[7] !== readResult) {
    t4 = Boolean(address) && Boolean(readResult.data) && areEqualAddresses(readResult.data, address);
    $[6] = address;
    $[7] = readResult;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = Boolean(address) && readResult.isFetching;
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = {
      isDropForgeAdmin: t4,
      isFetching: t5
    };
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}